import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import * as actions from './actions';
import { MspAjaxService } from 'projects/angular-clarity/src/app/services/ajax/msp-ajax.service';

@Injectable()
export class HaloMappingsEffects {
    load$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actions.loadMspHaloMappings),
            mergeMap(() =>
                this.ajax.get('/api/octiga/v3/msp/halo/tenant-mappings').pipe(
                    map((items) => actions.loadMspHaloMappingsSuccess({ items })),
                    catchError((error) => of(actions.loadMspHaloMappingsFailure({ error }))),
                ),
            ),
        ),
    );

    update$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actions.updateMspHaloMappings),
            mergeMap(({ items }) =>
                this.ajax.put('/api/octiga/v3/msp/halo/tenant-mappings', items).pipe(
                    map(() => actions.updateMspHaloMappingsSuccess({ items })),
                    catchError((error) => of(actions.updateMspHaloMappingsFailure({ error }))),
                ),
            ),
        ),
    );

    constructor(
        private actions$: Actions,
        private ajax: MspAjaxService,
    ) {}
}
